import "../assets/Page css/About.css";
import { useEffect, useRef, useState } from "react";
import Team from "../assets/images/About Us/new/Corporate Meeting Insight.jpg";
import HeroBg from "../assets/images/About Us/new/about-hero-bg.jpg";
import Profile_pic from "../assets/images/About Us/new/profile-pic.jpg";
import Profile_pic2 from "../assets/images/About Us/new/profile-pic1.jpg";
import Profile_pic3 from "../assets/images/About Us/new/profile-pic2.jpg";
import Profile_pic4 from "../assets/images/About Us/new/profile-pic3.jpg";
import why_choose_us from "../assets/images/About Us/new/why-choose-us.jpg";

//ICONS
import industry_icon from "../assets/icons/industry-icon.png";
import graduation_icon from "../assets/icons/graduation-icon.png";
import innovation_icon from "../assets/icons/innovation.png";
import excellence_icon from "../assets/icons/excellence.png";
import integrity_icon from "../assets/icons/integrity.png";
import growth_icon from "../assets/icons/growth.png";
import thropy_icon from "../assets/icons/thropy-icon.png";
import deep_industry_tree from "../assets/icons/deep-industry-root.png";
import medal_icon from "../assets/icons/medal_2955931.png";
import right_icon from "../assets/icons/check_9109805.png";
import star_icon from "../assets/icons/star-icon.png";
import placement_icon from "../assets/icons/palcement-icon.png";
import hands_on from "../assets/icons/hands-on-uproach.png";
import headquartes_icon from "../assets/icons/factory_11248062.png";
import delivery_icon from "../assets/icons/delivery_8830041.png";

// ─── Data ────────────────────────────────────────────────────

const heroStats = [
  { num: "500+", label: "Businesses & Industries Served" },
  { num: "5000+", label: "Students & Professionals Trained" },
  { num: "15+", label: "Years of Industry Excellence" },
  { num: "200+", label: "Corporate Training Batches Delivered" },
];

const identityCards = [
  {
    icon: industry_icon,
    title: "Industry Services Partner",
    desc: "A trusted engineering and technology partner delivering automation, embedded systems, software & digital marketing solutions to businesses across India.",
  },
  {
    icon: graduation_icon,
    title: "Professional Training Hub",
    desc: "A passionate educator delivering industry-aligned certification courses, internships, workshops, corporate training & live project programs for all career stages.",
  },
];

const values = [
  {
    icon: innovation_icon,
    title: "Innovation",
    desc: "Constantly pushing boundaries — embracing new technologies and creative thinking in everything we do for clients and learners.",
  },
  {
    icon: excellence_icon,
    title: "Excellence",
    desc: "Holding ourselves to the highest standards — in every project we deliver and every training program we run.",
    featured: true,
  },
  {
    icon: integrity_icon,
    title: "Integrity",
    desc: "Building lasting relationships through transparency, honesty, and always doing what's right for our clients and students.",
  },
  {
    icon: growth_icon,
    title: "Growth",
    desc: "Believing in continuous growth — for our clients' businesses, our students' careers, and our own team members every day.",
  },
  {
    icon: graduation_icon,
    title: "Collaboration",
    desc: "Working as true partners — deeply understanding your goals and aligning our expertise to help you achieve them together.",
    featured: true,
  },
  {
    icon: thropy_icon,
    title: "Impact",
    desc: "Every solution we build and every skill we teach is aimed at creating real, measurable, and lasting impact for people and businesses.",
  },
];

const timeline = [
  {
    year: "2009",
    title: "Company Founded",
    desc: "Skimitar Hindusthan Pvt Ltd established in Erode, Tamil Nadu — starting with industrial automation and engineering services.",
    badge: "Founded",
    badgeStyle: { background: "#E1F5EE", color: "#085041" },
  },
  {
    year: "2012",
    title: "Service Expansion",
    desc: "Expanded to include PLC, SCADA, and panel fabrication — onboarding first major industrial clients across Tamil Nadu.",
    badge: "Expansion",
    badgeStyle: { background: "#E6F1FB", color: "#0C447C" },
  },
  {
    year: "2015",
    title: "Training Division Launched",
    desc: "Launched certification courses in electrical, electronics, and automation — opening doors to students and working professionals.",
    badge: "Training Launch",
    badgeStyle: { background: "#EEEDFE", color: "#3C3489" },
  },
  {
    year: "2017",
    title: "Embedded Systems & IIoT Domain",
    desc: "Entered the Embedded Systems & IIoT space — delivering smart monitoring and connected industrial solutions to manufacturing clients.",
    badge: "New Domain",
    badgeStyle: { background: "#FAEEDA", color: "#633806" },
  },
  {
    year: "2019",
    title: "IT & Software Development",
    desc: "Expanded into web applications, AI solutions, and enterprise software — serving a new wave of digital-first businesses.",
    badge: "New Domain",
    badgeStyle: { background: "#EAF3DE", color: "#27500A" },
  },
  {
    year: "2021",
    title: "Digital Marketing & Corp Training",
    desc: "Launched Digital Marketing services and structured Corporate Training programs — supporting businesses in digital transformation.",
    badge: "New Domain",
    badgeStyle: { background: "#FAECE7", color: "#712B13" },
  },
  {
    year: "2023",
    title: "5000+ Students Milestone",
    desc: "Crossed 5000 students trained milestone — expanding pan-India operations and strengthening presence across multiple states.",
    badge: "Milestone",
    badgeStyle: { background: "#FCEBEB", color: "#A32D2D" },
  },
  {
    year: "2025",
    title: "Online Platform & AI Courses",
    desc: "Introduced online training platform, live project programs, and advanced AI & Data Science courses — stepping into the future of learning.",
    badge: "Future Ready",
    badgeStyle: { background: "#E6F1FB", color: "#0C447C" },
  },
];

const team = [
  {
    initials: Profile_pic,
    name: "Managing Director",
    role: "Founder & CEO",
    desc: "Visionary leader with 15+ years of expertise in industrial automation and engineering — driving Skimitar's strategic direction and growth across India.",
    avatarStyle: { background: "#FCEBEB", color: "#A32D2D" },
  },
  {
    initials: Profile_pic2,
    name: "Technical Head",
    role: "Head of Engineering Services",
    desc: "Seasoned automation engineer overseeing all technical projects — ensuring precision, quality, and innovation in every solution delivered to clients.",
    avatarStyle: { background: "#E6F1FB", color: "#0C447C" },
  },
  {
    initials: Profile_pic3,
    name: "Training Director",
    role: "Head of Training & Development",
    desc: "Industry professional with a passion for education — designing and delivering curriculum that bridges the gap between academics and real industry demands.",
    avatarStyle: { background: "#E1F5EE", color: "#085041" },
  },
  {
    initials: Profile_pic4,
    name: "Digital Marketing Head",
    role: "Head of Digital Strategy",
    desc: "Digital marketing strategist leading brand growth, online campaigns, and client acquisition across all digital platforms for Skimitar and its clients.",
    avatarStyle: { background: "#EEEDFE", color: "#3C3489" },
  },
];

const whyCards = [
  {
    icon: industry_icon,
    title: "Dual Expertise",
    desc: "Unique combination of industry services and professional training — all under one trusted brand with 15+ years of experience.",
  },
  {
    icon: deep_industry_tree,
    title: "Deep Industry Roots",
    desc: "Hands-on expertise across automation, IT, embedded systems & digital marketing serving 20+ industry sectors pan-India.",
  },
  {
    icon: graduation_icon,
    title: "Industry-Aligned Curriculum",
    desc: "Training programs continuously updated with real industry requirements — not just textbook content.",
  },
  {
    icon: hands_on,
    title: "Hands-On Approach",
    desc: "Every project and every training session is built around practical, real-world application — learn by doing.",
  },
  {
    icon: integrity_icon,
    title: "Pan-India Reach",
    desc: "Serving clients and training professionals across multiple Indian states — online and on-site with consistent quality.",
  },
  {
    icon: placement_icon,
    title: "Placement & Career Support",
    desc: "Dedicated career services — resume building, mock interviews, job referrals, and career counselling for every learner.",
  },
];

const certs = [
  {
    icon: medal_icon,
    title: "ISO 9001:2015 Certified",
    desc: "Internationally recognised quality management certification — ensuring consistent, high-quality service delivery.",
  },
  {
    icon: right_icon,
    title: "NSDC Affiliated",
    desc: "Approved training partner under National Skill Development Corporation — validating our training standards.",
  },
  {
    icon: graduation_icon,
    title: "Industry-Certified Courses",
    desc: "All training programs aligned with industry certification standards recognized by top employers.",
  },
  {
    icon: industry_icon,
    title: "Authorised Brand Partner",
    desc: "Official authorised partner of Mitsubishi, Siemens, Delta, Omron, Rockwell & ABB.",
  },
  {
    icon: thropy_icon,
    title: "Best Training Institute 2023",
    desc: "Awarded for excellence in professional training and skill development in the region.",
  },
  {
    icon: star_icon,
    title: "4.8/5 Student Rating",
    desc: "Consistently high ratings from 5000+ trained students across all batches and programs.",
  },
];

const presence = [
  {
    icon: headquartes_icon,
    iconBg: "#FCEBEB",
    title: "Headquarters & Training Centre",
    desc: "Our main office and training centre in Erode, Tamil Nadu — equipped with labs, live equipment, and expert faculty for hands-on learning.",
  },
  {
    icon: excellence_icon,
    iconBg: "#E6F1FB",
    title: "Online Training Platform",
    desc: "Live online training accessible from anywhere in India — with recorded sessions, assignments, and dedicated online mentorship support.",
  },
  {
    icon: delivery_icon,
    iconBg: "#E1F5EE",
    title: "Pan-India Service Delivery",
    desc: "On-site project delivery and technical services across Tamil Nadu, Karnataka, Andhra Pradesh, Maharashtra, Kerala & beyond.",
  },
  {
    icon: integrity_icon,
    iconBg: "#FAEEDA",
    title: "Corporate On-Site Training",
    desc: "We travel to your facility and deliver customized corporate training programs — zero disruption to your business operations.",
  },
];

// ─── SEQUENTIAL ANIMATION HOOK ───────────────────────────────
function useSequentialReveal(
  sectionRef,
  cardSelector = ".seq-card",
  animDuration = 600,
) {
  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;
    const cards = Array.from(section.querySelectorAll(cardSelector));
    if (!cards.length) return;
    let revealIndex = 0;
    let isAnimating = false;
    cards.forEach((card) => {
      card.classList.add("seq-hidden");
    });
    const revealNext = () => {
      if (revealIndex >= cards.length) return;
      const card = cards[revealIndex];
      card.classList.remove("seq-hidden");
      card.classList.add("seq-visible");
      revealIndex++;
      if (revealIndex < cards.length) {
        setTimeout(revealNext, animDuration + 80);
      } else {
        isAnimating = false;
      }
    };
    const handleHover = (hoveredCard) => {
      const idx = cards.indexOf(hoveredCard);
      for (let i = revealIndex; i <= idx; i++) {
        cards[i].classList.remove("seq-hidden");
        cards[i].classList.add("seq-visible");
      }
      if (idx >= revealIndex) revealIndex = idx + 1;
      if (revealIndex < cards.length && !isAnimating) {
        isAnimating = true;
        setTimeout(revealNext, animDuration + 80);
      }
    };
    cards.forEach((card) => {
      card.addEventListener("mouseenter", () => handleHover(card));
    });
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && revealIndex === 0) {
            isAnimating = true;
            revealNext();
            observer.unobserve(section);
          }
        });
      },
      { threshold: 0.15 },
    );
    observer.observe(section);
    return () => {
      observer.disconnect();
      cards.forEach((card) => {
        card.removeEventListener("mouseenter", () => handleHover(card));
      });
    };
  }, []);
}

// ═══════════════════════════════════════════════════════════════
// HERO
// ═══════════════════════════════════════════════════════════════
function Hero() {
  return (
    <section className="ab-hero-section position-relative overflow-hidden">
      <div className="ab-hero-bg position-absolute w-100 h-100">
        <img
          src={HeroBg}
          className="w-100 h-100"
          style={{ objectFit: "cover" }}
          alt=""
        />
      </div>
      <div
        className="container container_width px-3 position-relative"
        style={{ zIndex: 1 }}
      >
        <span className="ab-hero-badge d-inline-block px-2 py-1 mb-2 mb-md-3 rounded-4">
          About Skimitar Hindusthan
        </span>
        <p className="ab-hero-title fw-bolder mb-2 text-white">
          Driven by <span className="text-primary-red">Innovation.</span>
          <br />
          Defined by <span className="text-primary-red">Excellence.</span>
        </p>
        <p className=" ab_text_all mb-3 mb-md-4 col-12 col-sm-10 col-md-9 col-lg-7 text-white">
          For over 15 years, Skimitar Hindusthan Pvt Ltd has been building a
          legacy of engineering excellence and transforming careers — one
          project and one student at a time.
        </p>
        <div className="row g-2 ab-hero-stats-row">
          {heroStats.map((s) => (
            <div key={s.num} className="col-6 col-sm-6 col-lg-3">
              <div className="ab-stat-box rounded-4 border border-light bg-transparent card h-100">
                <div className="card-body p-1 p-md-2 text-center">
                  <span className="ab-stat-num text-white d-block">
                    {s.num}
                  </span>
                  <span className="ab-stat-lbl text-white">{s.label}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ─── STORY ────────────────────────────────────────────────────
function StorySection() {
  return (
    <section className="ab-story-section py-5 ">
      <div className="container container_width py-lg-5">
        <div className="row g-4 g-lg-5">
          <div className="col-lg-6">
            <span className="ab-story-lbl small text-uppercase fw-semibold">
              Our Story
            </span>
            <h3 className="fw-semibold mt-2 mb-4">
              Built on a Vision to Evolve, Innovate &amp; Succeed
            </h3>
            <p className="ab_text_all mb-4">
              Skimitar Hindusthan Pvt Ltd was founded in 2009 in Erode, Tamil
              Nadu with a singular vision — to bridge the gap between industry
              demands and skilled talent, while empowering businesses with
              cutting-edge technology solutions. What began as a focused
              industrial automation firm has grown into a multi-domain
              technology and training powerhouse.
            </p>
            <p className="ab_text_all mb-4">
              Today, Skimitar operates across four core domains — Industrial
              Automation, Embedded Systems & IIoT, IT & Software Development,
              and Digital Marketing — while running a thriving training division
              that has empowered thousands of students, working professionals,
              and corporate teams with future-ready skills and certifications.
            </p>
            <div className="row g-3 mb-4 mb-5">
              {identityCards.map((c) => (
                <div key={c.title} className="col-6">
                  <div className="ab-id-card card h-100 border bg-light-subtle rounded-2 shadow-sm">
                    <div className="card-body p-3">
                      <img
                        src={c.icon}
                        alt={c.title}
                        style={{
                          width: "36px",
                          height: "36px",
                          objectFit: "contain",
                        }}
                        className="d-block mb-2"
                      />
                      <p className="about-text ab-id-title small fw-bold text-uppercase mb-2">
                        {c.title}
                      </p>
                      <p className="ab_text_all about-text small mb-0">
                        {c.desc}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <p className="ab_text_all mb-4">
              Our strength lies in our unique dual identity — we are both a
              trusted industry partner and a passionate educator. This
              combination allows us to deliver solutions that are technically
              sound and deeply aligned with real-world requirements and market
              expectations.
            </p>
          </div>
          <div className="col-lg-6 d-flex flex-column">
            <div className="ab-vision-box border-start border-4 border-primary-red bg-light-subtle p-4 mt-4 mb-5">
              <span className="small text-uppercase fw-bold text-primary-red">
                Our Vision
              </span>
              <p className="mb-0 mt-2 fst-italic about-text">
                "To be India's most trusted technology and training partner —
                empowering industries to innovate and individuals to excel."
              </p>
            </div>
            <div className="ab-story-img-wrap position-relative mt-4 ms-4 flex-grow-1 d-flex">
              <div
                className="ab-vision-box position-absolute border-start border-top border-4 border-opacity-25"
                style={{
                  top: "-1.5rem",
                  left: "-1.5rem",
                  width: "7rem",
                  height: "7.5rem",
                }}
              ></div>
              <img
                className="img-fluid rounded-1 shadow-lg w-100 h-100 position-relative z-1 rounded-3"
                style={{ objectFit: "cover" }}
                src="https://lh3.googleusercontent.com/aida-public/AB6AXuATzBXWTfXfxXm7eMhn9VYqoxmSb6yPNc-f_obu0HBYsEG9caWZVMkqlo75YR1JD09gARuxf6masEpHB8SdJWkbrWS9nCMYZIy5GIMsyUYDPQ9OSup0Bq1nEs7x0CWxyYjQAGqbARI7XjBolbw_dBakL84Yht8VX7g9MN5nhjixOD9xex221dBgCewN8o8LaUKZmb3OiD1SNjP4MhzkvXyPaerMNyA0YsFqXtbfztBTA6fLcTEWLYWqWD2jRIlViGv5sMR6339CTQ"
                alt="Team collaborating"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// ─── VALUES ───────────────────────────────────────────────────
function MissionValues() {
  const sectionRef = useRef(null);
  useSequentialReveal(sectionRef, ".val-seq-card", 550);
  return (
    <section
      className="ab-values-section py-5 bg_color margin_top"
      ref={sectionRef}
    >
      <div className="container container_width py-lg-5">
        <div className="text-center mb-5">
          <span className="ab-sh-lbl small text-uppercase fw-bold text-primary-red">
            Mission &amp; Values
          </span>
          <h2 className="ab-sh-h display-5 fw-bolder text-uppercase mt-2">
            What Drives Us Every Single Day
          </h2>
        </div>
        <div className="ab-mission-banner border-0 shadow-sm rounded-2 mb-5">
          <div className="card-body bg-white p-4 p-lg-5">
            <span className="small text-uppercase ab-val-title fw-bold text-primary-red">
              Our Mission
            </span>
            <p className="about-text lead about-text mb-0 mt-2">
              To deliver innovative, reliable, and results-driven technology
              solutions to businesses — while equipping the next generation of
              professionals with industry-relevant skills that create lasting
              impact, sustainable careers, and measurable growth.
            </p>
          </div>
        </div>
        <div className="row g-4">
          {values.map((v) => (
            <div
              key={v.title}
              className={`col-md-4 val-seq-card seq-card ${v.featured ? "d-flex align-items-stretch" : ""}`}
            >
              <div className="ab-val-card card h-100 border-0 shadow rounded-0 w-100">
                <div className="card-body p-4 p-lg-5">
                  <img
                    src={v.icon}
                    alt={v.title}
                    style={{
                      width: "48px",
                      height: "48px",
                      objectFit: "contain",
                    }}
                    className="d-block mb-4"
                  />
                  <p className="ab-val-title h5 fw-semibold text-uppercase mb-3">
                    {v.title}
                  </p>
                  <p className="ab_text_all about-text small mb-0">{v.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ─── TIMELINE ─────────────────────────────────────────────────
function Timeline() {
  const sectionRef = useRef(null);
  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;
    const rows = Array.from(section.querySelectorAll(".tl-seq-row"));
    if (!rows.length) return;
    let revealIndex = 0;
    rows.forEach((row) => row.classList.add("tl-row-hidden"));
    const revealNext = () => {
      if (revealIndex >= rows.length) return;
      const row = rows[revealIndex];
      const yearSide = row.querySelector(".tl-year-side");
      const card = row.querySelector(".tl-card-side");
      const dot = row.querySelector(".tl-dot-wrap");
      if (dot) dot.classList.add("tl-dot-pop");
      setTimeout(() => {
        if (yearSide) yearSide.classList.add("tl-slide-in");
        if (card) card.classList.add("tl-slide-in");
      }, 150);
      row.classList.remove("tl-row-hidden");
      revealIndex++;
      if (revealIndex < rows.length) {
        setTimeout(revealNext, 700);
      }
    };
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && revealIndex === 0) {
            revealNext();
            observer.unobserve(section);
          }
        });
      },
      { threshold: 0.1 },
    );
    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      className="ab-timeline-section py-5 overflow-hidden"
      ref={sectionRef}
    >
      <div className="container container_width py-lg-5">
        <div className="text-center mb-5">
          <span className="ab-sh-lbl small text-uppercase fw-bold text-primary-red">
            Our Journey
          </span>
          <h2 className="ab-sh-h display-5 fw-bolder text-uppercase mt-2">
            15+ Years of Growth, Innovation &amp; Impact
          </h2>
        </div>
        <div className="ab-tl-wrap position-relative">
          <div
            className="ab-tl-vline d-none d-md-block position-absolute top-0 bottom-0 start-50 translate-middle-x bg-primary-red opacity-10"
            style={{ width: "4px" }}
          ></div>
          <ul className="list-unstyled mb-0">
            {timeline.map((item, i) => {
              const isRight = i % 2 !== 0;
              return (
                <li
                  key={item.year}
                  className="tl-seq-row ab-tl-row row g-3 g-md-4 mb-4 mb-md-5 position-relative"
                >
                  <div
                    className={`tl-year-side ab-tl-year-side d-none d-md-block col-md-5 ${isRight ? "order-2 text-start tl-from-right" : "text-end tl-from-left"}`}
                  >
                    <span className="ab-tl-yr-num display-4 fw-bold d-block">
                      {item.year}
                    </span>
                    <span className="ab-tl-yr-tag small text-uppercase fw-bold text-primary-red">
                      {item.badge}
                    </span>
                  </div>
                  <div className="tl-dot-wrap ab-tl-dot d-none d-md-flex col-md-2 justify-content-center align-items-center">
                    <div
                      className="rounded-circle bg-white border border-4"
                      style={{
                        width: "1.5rem",
                        height: "1.5rem",
                        borderColor: "#cc0000",
                      }}
                    ></div>
                  </div>
                  <div
                    className={`tl-card-side col-12 col-md-5 ${isRight ? "order-1 order-md-3 tl-from-left" : "order-3 tl-from-right"}`}
                  >
                    <div
                      className="ab-tl-card card h-100 border-0 shadow-sm rounded-0"
                      style={{
                        borderLeft: "4px solid #cc0000",
                        borderRight: isRight ? "4px solid #cc0000" : "none",
                      }}
                    >
                      <div className="card-body p-4">
                        <div className="ab-tl-mob-yr d-md-none mb-3">
                          <span className="ab-tl-yr-num h3 fw-bold d-block">
                            {item.year}
                          </span>
                          <span className="ab-tl-yr-tag small text-uppercase fw-bold text-primary-red">
                            {item.badge}
                          </span>
                        </div>
                        <p className="ab-tl-card-title small fw-bold text-uppercase mb-2">
                          {item.title}
                        </p>
                        <p className="ab_text_all about-text small mb-3">
                          {item.desc}
                        </p>
                        <span
                          className="ab-tl-badge badge rounded-pill px-3 py-2 small"
                          style={item.badgeStyle}
                        >
                          {item.badge}
                        </span>
                      </div>
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
}

// ─── TEAM ─────────────────────────────────────────────────────
function TeamSection() {
  return (
    <section className="ab-team-section py-5 bg_color margin_top">
      <div className="container container_width py-lg-5">
        <div className="mb-5">
          <span className="ab-sh-lbl small text-uppercase fw-bold text-primary-red">
            Our Team
          </span>
          <h2 className="ab-sh-h display-5 fw-bolder text-uppercase mt-2">
            The Experts Behind Every Success
          </h2>
          <p className="ab_text_all lead about-text mt-3 col-lg-8">
            Our leadership team brings together decades of industry experience
            across automation, technology, and education — united by a shared
            passion for innovation and excellence.
          </p>
        </div>
        <div className="row align-items-stretch">
          <div className="col-12 col-md-6 d-flex flex-column">
            {team.map((m) => (
              <div key={m.name} className="mt-4 flex-grow-1">
                <div className="ab-team-card card h-100 border-0 shadow-sm rounded-0">
                  <div className="card-body p-3 d-flex flex-column">
                    <div className="d-flex align-items-start gap-3">
                      <div
                        className="ab-team-avatar d-flex align-items-center justify-content-center rounded-5"
                        style={{
                          ...m.avatarStyle,
                          width: "60px",
                          height: "60px",
                        }}
                      >
                        <img
                          src={m.initials}
                          alt="profile"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "50%",
                          }}
                        />
                      </div>
                      <div className="flex-grow-1">
                        <h4 className="h6 team-name fw-bold mb-1">{m.name}</h4>
                        <p className="small team-role text-primary-red mb-0">
                          {m.role}
                        </p>
                      </div>
                    </div>
                    <p className="ab_text_all  mt-3 mb-0">{m.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="col-12 col-md-6 d-flex">
            <div className="team-img-wrapper">
              <img src={Team} alt="team" />
            </div>
          </div>
        </div>
        <div className="ab-team-note border mt-5 text-center">
          <div className="card-body py-3">
            <span className="ab_text_all fw-semibold about-text">
              Backed by 50+ engineers, trainers, developers &amp; marketing
              professionals dedicated to your success.
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}

// ═══════════════════════════════════════════════════════════════
// WHY CHOOSE US — EXACT VIDEO STYLE
// Left: accordion list (icon + title + animated underline + desc)
// Right: sticky image with corner accents
// ═══════════════════════════════════════════════════════════════
function WhyUs() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.12 },
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="ab-why-section py-5 " ref={sectionRef}>
      <div className="container container_width py-lg-5">
        {/* Header */}
        <div
          className="mb-5"
          style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? "translateY(0)" : "translateY(28px)",
            transition: "opacity 0.6s ease, transform 0.6s ease",
          }}
        >
          <span className="ab-sh-lbl small text-uppercase fw-bold text-primary-red">
            Why Choose Us
          </span>
          <h2 className="ab-sh-h display-5 fw-bolder text-uppercase mt-2 mb-0">
            What Truly Sets Skimitar Apart
          </h2>
        </div>

        {/* Main 2-col grid */}
        <div className="ab-why-grid">
          {/* LEFT — Accordion */}
          <div
            className="ab-why-img-col"
            style={{
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? "translateX(0)" : "translateX(48px)",
              transition: "opacity 0.7s ease 0.25s, transform 0.7s ease 0.25s",
            }}
          >
            <div className="ab-why-img-frame">
              <img
                src={why_choose_us}
                alt="Why Choose Skimitar"
                className="ab-why-img"
              />
            </div>
          </div>

          {/* RIGHT — Sticky image */}
          <div className="ab-why-acc-col">
            <ul className="ab-why-list">
              {whyCards.map((w, i) => (
                <li
                  key={w.title}
                  className={[
                    "ab-why-item",
                    isVisible ? "ab-why-item--in" : "",
                    activeIndex === i ? "ab-why-item--active" : "",
                  ]
                    .filter(Boolean)
                    .join(" ")}
                  style={{ transitionDelay: isVisible ? `${i * 85}ms` : "0ms" }}
                  onClick={() => setActiveIndex(i)}
                >
                  {/* Icon + Title + Chevron */}
                  <div className="ab-why-row">
                    <img
                      src={w.icon}
                      alt={w.title}
                      className="ab-why-ico-img"
                    />
                    <span className="ab-why-title-txt">{w.title}</span>
                    <svg
                      className="ab-why-chevron"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="6 9 12 15 18 9" />
                    </svg>
                  </div>

                  {/* Animated red underline — exact video style */}
                  <div className="ab-why-underline-track">
                    <div className="ab-why-underline-fill" />
                  </div>

                  {/* Expandable description */}
                  <div className="ab-why-body">
                    <p className="ab-why-body-txt">{w.desc}</p>
                  </div>
                </li>
              ))}
            </ul>

            {/* "1 / 6 — Title" counter */}
            <div className="ab-why-counter">
              <span className="ab-why-counter-dot" />
              {activeIndex + 1}&nbsp;/&nbsp;{whyCards.length}&nbsp;—&nbsp;
              {whyCards[activeIndex].title}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// ─── CERTIFICATIONS ───────────────────────────────────────────
function Certifications() {
  const sectionRef = useRef(null);
  useSequentialReveal(sectionRef, ".cert-seq-card", 500);
  return (
    <section
      className="ab-cert-section py-5 bg_color margin_top"
      ref={sectionRef}
    >
      <div className="container container_width py-lg-5">
        <div className="text-center mb-5">
          <span className="ab-sh-lbl small text-uppercase fw-bold text-primary-red">
            Recognition &amp; Accreditation
          </span>
          <h2 className="ab-sh-h display-5 fw-bolder text-uppercase mt-2">
            Recognised for Quality &amp; Excellence
          </h2>
        </div>
        <div className="row g-4">
          {certs.map((c) => (
            <div key={c.title} className="col-md-6 col-lg-4 cert-seq-card">
              <div className="ab-cert-card card h-100 border-0 shadow-sm rounded-0 bg-white">
                <div className="card-body p-4">
                  <img
                    src={c.icon}
                    alt={c.title}
                    style={{
                      width: "44px",
                      height: "44px",
                      objectFit: "contain",
                    }}
                    className="d-block mb-3"
                  />
                  <p className="ab-cert-title text-dark small fw-bold text-uppercase mb-2">
                    {c.title}
                  </p>
                  <p className="ab_text_all about-text small mb-0">{c.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ─── PRESENCE ─────────────────────────────────────────────────
function Presence() {
  return (
    <section className="ab-pres-section py-5 ">
      <div className="container container_width py-lg-5">
        <div className="mb-5">
          <span className="ab-sh-lbl small text-uppercase fw-bold text-primary-red">
            Our Presence
          </span>
          <h2 className="ab-sh-h display-5 fw-bolder text-uppercase mt-2">
            Rooted in Erode. Reaching Across India.
          </h2>
        </div>
        <div className="row g-4 mb-4">
          {presence.map((p) => (
            <div key={p.title} className="col-md-6">
              <div className="ab-pres-card card h-100 border shadow-sm rounded-2">
                <div className="card-body d-flex gap-3 p-4">
                  <div
                    className="ab-pres-ico rounded-5 mt-4 flex-shrink-0 d-flex align-items-center justify-content-center rounded-2"
                    style={{
                      background: "transparent",
                      width: "52px",
                      height: "52px",
                    }}
                  >
                    <img
                      src={p.icon}
                      alt={p.title}
                      style={{
                        width: "44px",
                        height: "44px",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                  <div>
                    <p className="ab-pres-title my-2 small fw-bold text-uppercase mb-1">
                      {p.title}
                    </p>
                    <p className="ab_text_all about-text small mb-0">
                      {p.desc}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ─── CTA ──────────────────────────────────────────────────────
function CTA() {
  return (
    <section className="ab-cta-section py-5  margin_top">
      <div className="py-lg-5">
        <div
          className="ab-cta-wrap rounded-0 shadow-lg p-4 p-lg-5"
          style={{
            background: "linear-gradient(135deg, #cc0000 0%, #930000 100%)",
          }}
        >
          <div className="row g-4 align-items-center">
            <div className="col-lg-7 text-center text-lg-start">
              <h2 className="ab-cta-title display-4 fw-bolder text-white text-uppercase mb-3">
                Let's Build Something Great Together.
              </h2>
              <p className="ab_text_all lead text-white opacity-75 mb-0">
                Whether you're looking to transform your business operations or
                launch a rewarding career —{" "}
                <span className="fw-bold"> Skimitar Hindusthan </span> is your
                trusted partner every step of the way.
              </p>
            </div>
            <div className="col-lg-5">
              <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center justify-content-lg-end">
                <button className="btn ab-btn-white px-4 py-3 fw-bold text-uppercase small">
                  Get a Free Consultation
                </button>
                <button className="btn ab-btn-ghost px-4 py-3 fw-bold text-uppercase small">
                  Explore Training Programs
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// ─── MAIN EXPORT ──────────────────────────────────────────────
export default function About() {
  return (
    <div className="about-page">
      <Hero />
      <StorySection />
      <MissionValues />
      <Timeline />
      <TeamSection />
      <WhyUs />
      <Certifications />
      <Presence />
      <CTA />
    </div>
  );
}
